export default __webpack_public_path__ + "static/media/icon-no-drone.e738dd1a.png";